export const MESSAGE_TIMEOUT_MS = 5000;

function parseConfiguredNumber(rawValue) {
	if (typeof rawValue !== "string") {
		return { raw: null, value: null, configured: false, valid: false };
	}
	const trimmed = rawValue.trim();
	if (!trimmed) {
		return { raw: null, value: null, configured: false, valid: false };
	}
	const parsed = Number(trimmed);
	return {
		raw: trimmed,
		value: Number.isFinite(parsed) ? parsed : null,
		configured: true,
		valid: Number.isFinite(parsed) && parsed > 0,
	};
	}

const defaultApiBaseUrl = (() => {
	if (typeof window !== "undefined") {
		return `${window.location.protocol}//${window.location.host}`;
	}
	return "https://easyjob.cedolinoweb.net";
})();

export const API_BASE_URL =	process.env.REACT_APP_API_BASE_URL?.trim() || defaultApiBaseUrl;

const gpsAccuracyMax = parseConfiguredNumber(process.env.REACT_APP_GPS_ACCURACY_MAX);

export const GPS_INSTANCE_CONFIG = {
	gps_accuracy_max_raw: gpsAccuracyMax.raw,
	gps_accuracy_max: gpsAccuracyMax.value,
	gps_accuracy_max_configured: gpsAccuracyMax.configured,
	gps_accuracy_max_valid: gpsAccuracyMax.valid,
};